import { cachedAxios } from '../services/cache/CachedAxios';

const FIN_SERVICE_URL = process.env.REACT_APP_FIN_SERVICE_URL;

interface ConfirmTransactionResponse {
    signatures: (string | 'error')[];
    SuccessTransactions: number;
    CountTransactions: number;
    RejectedTransactions?: number;
    statusCode: number;
}

async function sendTransactionToService(data: string[]): Promise<ConfirmTransactionResponse> {
    const body = {
        data,
        type: "sol",
        network: "mainnet",
    }

    console.log('Sending request to API:', body);

    const response = await cachedAxios.post<ConfirmTransactionResponse>(
      `${FIN_SERVICE_URL}/blockchain/send-confirm-transaction`,
      body,
      { skipCache: true }
    );

    console.log('API response:', response);
    
    if (!response) {
      throw new Error('Invalid response from server');
    }

    return response;
}

export async function sendConfirmTransaction(data: string[]): Promise<ConfirmTransactionResponse> {
    return await sendTransactionToService(data);
}
